import React, { useState, useEffect } from 'react';
import {
  ScrollView,
  StyleSheet,
  TouchableHighlight,
  View,
  Platform,
  SafeAreaView,
} from 'react-native';
import Toast from 'react-native-root-toast';
import Icon from '../Icon';
import {
  saveAirLoyalty,
  saveCarLoyalty,
  saveHotelLoyalty,
  saveRailLoyalty,
  getAirVendor,
  getCarVendor,
  getHotelVendor,
  deleteAirLoyalty,
  deleteCarLoyalty,
  deleteHotelLoyalty,
  deleteRailLoyalty,
} from '../../services/api/profile.service';
import Button, { BUTTON_TYPES } from '../Button';
import InputForm from '../InputForm';
import PickerSelect from '../PickerSelect';
import FloatButton from '../FloatButton';
import { searchTypesEnum } from '../../constants/Enums';
import { CommonProperties, Color, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import BottomButton from '../BottomButton';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
const AIR_VENDOR_PREFERENCE_EXISTS = 'Air Vendor Preference already exists';
const AIRLINE = 'Airline';
const HOTELCHAIN = 'Hotel Chain';
const CARCOMPANY = 'Car Company';
const RAILVENDOR = 'Rail Vendor';

const LoyaltyItem = (props) => {
  const { tKey } = useComponentTKey('LoyaltyForm');
  const { t } = useTranslation(i18nNS.me);
  return (
    <>
      {props.item && (
        <View style={styles.loyaltyContainer}>
          <View style={styles.headerBox}>
            <BaseText style={styles.headerText}>{props.label}</BaseText>
            {props.showRemove && (
              <TouchableHighlight
                onPress={() => {
                  props.onRemove(props.index);
                }}
                style={styles.headerIcon}
              >
                <View>
                  <Icon size={12} color={Color.required} name="minus" />
                </View>
              </TouchableHighlight>
            )}
          </View>
          <PickerSelect
            label={t(tKey('Name'))}
            onValueChange={(value) => props.onChangeCompany(value, props.index)}
            items={props.selectList}
            value={props.item?.company}
            placeholder={{ label: t(tKey('SelectAnItem')) }}
            errorMessage={props.errorMessageDropDown}
          />
          <InputForm
            styleContainer={CommonStyles.my2}
            label={t(tKey('LoyaltyNumber'))}
            value={props.item?.number}
            onChangeText={(text) => props.onChangeNumber(text, props.index)}
            errorMessage={props.errorMessage}
          />
        </View>
      )}
    </>
  );
};
const getComponentLabel = (type) => {
  switch (type) {
    case searchTypesEnum.AIR:
      return AIRLINE;
    case searchTypesEnum.HOTEL:
      return HOTELCHAIN;
    case searchTypesEnum.CAR:
      return CARCOMPANY;
    case searchTypesEnum.RAIL:
      return RAILVENDOR;
    default:
      return '';
  }
};
const LoyaltyForm = ({ loyaltyItem, type, loyaltyAirList, onSubmit }) => {
  const { tKey } = useComponentTKey('LoyaltyForm');
  const { t } = useTranslation(i18nNS.me);
  const [loyaltyList, setLoyaltyList] = useState([
    {
      number: '',
      company: '',
    },
  ]);
  const [selectList, setSelectList] = useState([]);
  const [label, setLabel] = useState('');
  const [loading, setLoading] = useState(false);
  let scrollView = null;
  const [loyaltyExistsError, setloyaltyExistsError] = useState('');
  const [loyaltyErrorMessage, setLoyaltyErrorMessage] = useState();
  const [loyaltyErrorMessageDropDown, setLoyaltyErrorMessageDropDown] = useState();
  const addLoyaltyItem = () => {
    setLoyaltyList([
      ...loyaltyList,
      {
        number: '',
        company: '',
      },
    ]);
  };

  const removeLoyaltyItem = (index) => {
    const list = [...loyaltyList];
    list[index] = null;
    setLoyaltyList(list.filter((i) => i));
  };

  const onChangeCompany = (company, index) => {
    setLoyaltyErrorMessageDropDown(null);
    const list = [...loyaltyList];
    list[index].company = company;
    setLoyaltyList(list);
  };

  const onChangeNumber = (number, index) => {
    setLoyaltyErrorMessage(null);
    const list = [...loyaltyList];
    list[index].number = number;
    setLoyaltyList(list);
  };

  const transformList = (list) => {
    return list
      .filter((i) => i !== null)
      .map((i) => ({
        VendorCode: i.company,
        ProgramNumber: i.number.replace(/\s+/g, ''),
        VendorId: i.id || 0,
      }));
  };

  const onPressSubmit = async () => {
    if (loading) {
      return;
    }
    const item = loyaltyItem;
    let res = null;

    setLoading(true);

    if (!isValid()) {
      setLoading(false);
      return;
    }

    switch (type) {
      case searchTypesEnum.AIR:
        res = await saveAirLoyalty(transformList(loyaltyList));
        break;
      case searchTypesEnum.CAR:
        res = await saveCarLoyalty(transformList(loyaltyList));
        break;
      case searchTypesEnum.HOTEL:
        res = await saveHotelLoyalty(transformList(loyaltyList));
        break;
      case searchTypesEnum.RAIL:
        res = await saveRailLoyalty(transformList(loyaltyList));
        break;
    }

    setLoading(false);

    if (res) {
      if (res) {
        if (typeof res === 'string' && res.includes(AIR_VENDOR_PREFERENCE_EXISTS)) {
          setloyaltyExistsError(AIR_VENDOR_PREFERENCE_EXISTS);
          return;
        } else {
          if (Platform.OS === 'android') {
            Toast.show(t(tKey('LoyaltySaved')), Toast.durations.SHORT);
          }
        }
      }
      if (item) {
        onSubmit(item.id, type);
      } else {
        onSubmit(null, type);
      }
    }
  };

  const onPressDelete = async () => {
    if (loading) {
      return;
    }

    let res = null;

    setLoading(true);

    switch (type) {
      case searchTypesEnum.AIR:
        res = await deleteAirLoyalty(loyaltyItem.id);
        break;
      case searchTypesEnum.CAR:
        res = await deleteCarLoyalty(loyaltyItem.id);
        break;
      case searchTypesEnum.HOTEL:
        res = await deleteHotelLoyalty(loyaltyItem.id);
        break;
      case searchTypesEnum.RAIL:
        res = await deleteRailLoyalty(loyaltyItem.id);
        break;
    }

    setLoading(false);

    if (res) {
      if (Platform.OS === 'android') {
        Toast.show(t(tKey('LoyaltyDeleted')), Toast.durations.SHORT);
      }
      onSubmit(loyaltyItem.id, type);
    }
  };

  const isValid = () => {
    let errorMessage;
    let errorMessageDropDown;
    if (loyaltyList[0].number.trim().length === 0) {
      errorMessage = t('common:Error.requiredLoyaltyNumber');
      setLoyaltyErrorMessage(errorMessage);
    } else {
      if (/[!@#$%^&*(),.?":{}|<>]/.test(loyaltyList[0].number)) {
        errorMessage = t('common:Error.invalidLoyaltyNumber');
        setLoyaltyErrorMessage(errorMessage);
        return false;
      }
    }
    if (
      !loyaltyList[0].company ||
      !selectList.some((item) => item.value === loyaltyList[0].company)
    ) {
      const componentLabel = getComponentLabel(type);
      errorMessageDropDown = `Please Select ${componentLabel}`;
      setLoyaltyErrorMessageDropDown(errorMessageDropDown);
    }
    if (errorMessage || errorMessageDropDown) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    switch (type) {
      case searchTypesEnum.AIR:
        setLabel(t('common:Air'));
        getAirVendor().then((data) => {
          let newData = data;
          if (loyaltyAirList?.length > 0) {
            newData = data.filter((item) => {
              return !loyaltyAirList.some((loyaltyItem) => loyaltyItem.label === item.Name);
            });
          }
          setSelectList(
            newData?.map((i) => ({
              label: i.Name,
              value: i.Code,
            }))
          );
        });
        break;
      case searchTypesEnum.CAR:
        setLabel(t('common:Car'));
        getCarVendor().then((data) => {
          setSelectList(
            data.map((i) => ({
              label: i.VendorName,
              value: i.VendorCode,
            }))
          );
        });
        break;
      case searchTypesEnum.HOTEL:
        setLabel(t('common:Hotel'));
        getHotelVendor().then((data) => {
          setSelectList(
            data.map((i) => ({
              label: i.HotelChainName.trim()
                .split(/[\s,\t,\n]+/)
                .join(' '),
              value: i.HotelChainCode,
            }))
          );
        });
        break;
      case searchTypesEnum.RAIL:
        setLabel(t('common:Rail'));
        setSelectList([
          {
            label: 'AMTRAK SERVICE',
            value: '2V',
          },
        ]);
        break;
    }
  }, [type, t]);

  useEffect(() => {
    if (loyaltyItem) {
      setLoyaltyList([loyaltyItem]);
    }
  }, [loyaltyItem]);

  return (
    <SafeAreaView style={CommonStyles.flex1}>
      <ScrollView
        ref={(ref) => (scrollView = ref)}
        onContentSizeChange={() => {
          if (scrollView != null) {
            scrollView.scrollToEnd({ animated: true });
          }
        }}
      >
        <View style={CommonStyles.mx3}>
          <BaseText>{loyaltyExistsError}</BaseText>
          {loyaltyList.map((item, index) => (
            <LoyaltyItem
              key={index}
              label={label}
              item={item}
              selectList={selectList}
              onRemove={removeLoyaltyItem}
              showRemove={loyaltyList.length > 1}
              number={item ? item.number : null}
              company={item ? item.company : null}
              onChangeCompany={onChangeCompany}
              onChangeNumber={onChangeNumber}
              index={index}
              errorMessage={loyaltyErrorMessage ? loyaltyErrorMessage : null}
              errorMessageDropDown={loyaltyErrorMessageDropDown}
            />
          ))}
          {loyaltyItem && (
            <Button
              type={BUTTON_TYPES.OUTLINED}
              color={Color.required}
              style={[CommonStyles.py3, CommonStyles.borderRadius4]}
              labelStyle={CommonStyles.h4}
              onPress={onPressDelete}
              label={t(tKey('DeleteLoyalty'))}
            />
          )}
        </View>
      </ScrollView>
      {!loyaltyItem && <FloatButton onPress={addLoyaltyItem} iconName="plus" />}
      <BottomButton loading={loading} onPress={onPressSubmit} label={t('common:Save')} />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  headerBox: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.py3,
  },
  headerText: {
    fontWeight: 'bold',
  },
  headerIcon: {
    width: 18,
    height: 18,
    borderColor: Color.required,
    borderWidth: 1,
    ...CommonProperties.borderRadius,
    ...CommonProperties.centerAlignment,
  },
  loyaltyContainer: {
    backgroundColor: 'white',
    ...CommonProperties.my3,
    ...CommonProperties.p3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
  },
});

export default LoyaltyForm;
